<template>
    <div class="StatsBlocks">
        <div class="container">
            <BaseHeading
                :heading="heading"
                :preheading="preHeading"
                tag="h2"
            >
            </BaseHeading>
            <div class="StatsBlocks__blocks">
                <div
                    v-for="(stat, index) in stats"
                    :key="index"
                    class="StatsBlocks__block"
                >
                    <h2
                        :class="'text--' + colours[index]"
                    >
                        {{ stat.heading }}
                    </h2>
                    <p
                        class="StatsBlocks__block-text"
                    >
                        {{ stat.text }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'StatsBlocks',
    props: {
        heading: {
            type: String,
            default: null,
        },
        preHeading: {
            type: String,
            default: null,
        },
        stats: {
            type: Array,
            default: null,
        }
    },
    data: () => ({
        colours: ['blue', 'green', 'blue-charcoal', 'bean']
    })
}
</script>
<style lang="scss" scoped>
    .StatsBlocks {
        margin: getSpacing('large') 0;
        text-align: center;
    }

    .StatsBlocks__blocks {
        display: flex;
        flex-wrap: wrap;
        margin-top: getSpacing('medium');
        text-align: center;

        @include media-query(desk) {
            margin-left: -(getSpacing(spacer));
            margin-right: -(getSpacing(spacer));
        }

        h2 {
            margin-bottom: 0.3em;
            font-size: 48px;
            font-weight: 800;
            font-family: 'NationalBlack';

            @include media-query(desk) {
                font-size: 96px;
            }
        }
    }

    .StatsBlocks__block {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 50%;
        margin-bottom: getSpacing('medium');

        &:nth-child(odd) {
            padding-right: 10px;
            border-right: 1px solid getColour('grey', 'medium');
        }

        &:nth-child(even) {
            padding-left: 10px;
        }

        @include media-query(desk) {
            width: 25%;
            height: 180px;
            margin-bottom: 0;
            padding: 0 getSpacing('medium') !important;

            &:not(:last-child) {
                border-right: 1px solid getColour('grey', 'medium');
            }
        }

        p {
            max-width: 300px;
        }
    }
</style>
